import {
  Box, Paper, Stack, Typography,
} from '@mui/material';
import { FilledStarIcon } from 'assets/icons';
import { IReview } from 'pages/review/interface';
import React from 'react';
import { dateFormat } from 'utils/formats';

interface Props {
  review: IReview;
}

const Review = ({ review }: Props) => (
  <div data-testid="review" className="col-sm-4 col-lg-4 col-md-4 mb-4 mt-4">
    <Paper
      sx={{
        p: { xs: 4, md: 4 },
        borderRadius: (t) => t.custom.borderRadius,
        boxShadow: (t) => t.custom.boxShadow,
      }}
    >
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Box display="flex" gap={2} alignItems="center" mt={-1}>
          <Box
            height={32}
            width={32}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              borderRadius: '50%',
              background: (t) => t.palette.secondary.light,
            }}
          >
            <FilledStarIcon
              sx={{ fontSize: 16, color: 'secondary.dark' }}
            />
          </Box>
          <Typography variant="body2" color="secondary.dark">
            {`${review.rating}`}
            /5
          </Typography>
        </Box>
        <Box justifyContent="flex-end" alignItems="flex-end">
          <Typography variant="body2" color="text.secondary">
            {`${dateFormat(review.createdAt.toString())}`}
          </Typography>
        </Box>
      </Box>
      <Typography
        variant="body1"
        mb={2}
      >
        {`${review.sessionId.title}`}
      </Typography>
      <Typography
        variant="body2"
        mb={2}
      >
        {`${review.review}`}
      </Typography>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <Box display="flex" alignItems="center" gap={2}>
          {review.userId?.profileImgUrl ? (
            <Box
              component="img"
              src={`${review.userId.profileImgUrl}`}
              alt="profile-image"
              sx={{
                height: 50,
                width: 50,
                display: 'block',
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <Box
              sx={{
                height: 50,
                width: 50,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                backgroundColor: '#ccc',
                color: '#fff',
                fontWeight: 'bold',
              }}
            >
              {review.fullName
                .split(' ')
                .map((name) => name.charAt(0).toUpperCase())
                .join('')}
            </Box>
          )}

          <Box>
            <Typography fontWeight="medium" variant="body2">
              {`${review.fullName}`}
            </Typography>
            <Typography fontWeight="medium" color="text.secondary" variant="body2">
              {`${review.designation}`}
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Paper>
  </div>
);
export default Review;
